import {useMutation} from "@tanstack/react-query";
import {updateClaimCategory} from "../services/ClaimCategoryService";

export function useClaimCategoryUpdate() {
    return useMutation({
        mutationFn: ({id, payload}) => updateClaimCategory(id, payload),
    });
}
